export default __webpack_public_path__ + "static/media/azracan.cc275abf.jpg";